import React from "react";
import { Link } from "react-router-dom";
import history from "../images/perfume_image/history.jpeg";
import shopphoto from "../images/perfume_image/shopphoto.jpeg";
import intro from "../images/perfume_image/intro_image.jpeg";

export default function About() {
  const container = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "70px 20px",
    fontFamily: "Inter, sans-serif",
    color: "#475569",
  };

  const section = {
    display: "flex",
    gap: "70px",
    alignItems: "center",
    padding: "90px 0",
    flexWrap: "wrap",
  };

  const heading = {
    fontSize: "40px",
    fontWeight: "800",
    color: "#0f172a",
    marginBottom: "24px",
  };

  const text = {
    fontSize: "18px",
    lineHeight: "1.85",
    marginBottom: "22px",
  };

  const divider = {
    border: "none",
    borderTop: "1px solid #e5e7eb",
  };

  const imageCard = {
    flex: 1,
    minWidth: "320px",
    height: "420px",
    borderRadius: "16px",
    overflow: "hidden",
    border: "1px solid #e5e7eb",
    boxShadow: "0 18px 35px rgba(0,0,0,0.08)",
    background: "#fff",
  };

  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  return (
    <div style={{ background: "#ffffff" }}>
      <div style={container}>

        {/* SECTION 1 */}
        <section style={section}>
          <div style={{ flex: 1 }}>
            <h1 style={heading}>Our Heritage: From 1960 to Today</h1>

            <p style={text}>
              Aromora Naturals is not just a brand; it is a three-generation journey of passion, heritage, and the pursuit of the perfect scent. Our story began in 1960, founded by the visionary Haji Mohammad Yameen under the name Royal Perfumers & Fragrances.
            </p>

            <p style={text}>
              For decades, we stood as a cornerstone of the legendary Kannauj perfume industry, mastering the ancient art of Kannauj Attar in the heart of Uttar Pradesh. Today, as the third generation takes the helm, we have evolved. We have taken the secret formulations and "Royal" standards of our grandfather and infused them with a modern commitment to purity.
            </p>

            <p style={text}>
              Royal Perfumers & Fragrances has now blossomed into Aromora Naturals.
            </p>
          </div>

          <div style={imageCard}>
            <img src={intro} alt="Heritage" style={imageStyle} />
          </div>
        </section>

        <hr style={divider} />

        {/* SECTION 2 */}
        <section style={{ ...section, flexDirection: "row-reverse" }}>
          <div style={{ flex: 1 }}>
            <h2 style={heading}>Our Mission</h2>

            <p style={text}>
              To bridge the gap between ancient Indian perfumery and modern wellness. We encourage creativity and innovation while staying rooted in the ethical, sustainable, and natural practices that have defined our family for over six decades.
            </p>
          </div>

          <div style={imageCard}>
            <img src={history} alt="Mission" style={imageStyle} />
          </div>
        </section>

        <hr style={divider} />

        {/* SECTION 3 */}
        <section style={section}>
          <div style={{ flex: 1 }}>
            <h2 style={heading}>The Art of Kannauj, Delivered Globally</h2>

            <p style={text}>
              While our production remains deeply rooted in the historic soil of Kannauj, our reach is truly global. Aromora Naturals continues the proud tradition of exporting the finest Indian scents to the UK, USA, UAE, Australia, France, and beyond. We don't just sell fragrances; we bottle the science of everlasting memories.
            </p>
          </div>

          <div style={imageCard}>
            <img src={shopphoto} alt="Global Presence" style={imageStyle} />
          </div>
        </section>

        <hr style={divider} />

        {/* SECTION 4 */}
        <section style={{ padding: "80px 0" }}>
          <h2 style={heading}>Why the Change?</h2>

          <p style={text}>
            "As the third generation of this family business, my goal was to honor my grandfather’s empire while adapting to the needs of the modern world. Aromora Naturals represents the 'Aroma' of our heritage combined with the 'Natural' purity our customers deserve. We are keeping the soul of Royal Perfumers alive, but with a fresh, sustainable face for the future."
          </p>
        </section>

        <hr style={divider} />

        {/* SECTION 5 */}
        <section style={{ padding: "80px 0" }}>
          <p style={text}>
            In 1960, Haji Mohammad Yameen set out to bottle the soul of India. Under the name Royal Perfumers, he built an empire in Kannauj—the perfume capital of the world—defined by integrity and the timeless art of the Deg-Bhapka (traditional distillation).
          </p>

          <p style={text}>
            Today, the third generation of his lineage introduces Aromora Naturals.
          </p>

          <p style={text}>
            We haven't changed our secrets; we’ve simply returned to our roots. Aromora Naturals takes the "Royal" standard of our grandfather and pairs it with a 21st-century promise: 100% Transparency, Sustainable Sourcing, and Ethical Craftsmanship. From the historic fields of Uttar Pradesh to the boutiques of London and New York, we are bringing the ancient alchemy of Kannauj to the modern connoisseur.
          </p>
        </section>

        <hr style={divider} />

        {/* SECTION 6 */}
        <section style={{ padding: "80px 0" }}>
          <h2 style={heading}>The Royal Legacy (1960) → The Aromora Future (Today)</h2>

          <ul style={{ fontSize: "18px", lineHeight: "2", paddingLeft: "20px" }}>
            <li>Founded by Haji Mohammad Yameen → Led by the 3rd Generation</li>
            <li>Mastered the Art of Kannauj Attar → Sustainable & Eco-Friendly Packaging</li>
            <li>Trusted by International Markets → Direct-to-Consumer Purity & Quality</li>
            <li>60+ Years of Expertise → Modern, Science-Backed Natural Blends</li>
          </ul>

          <Link
            to="/contact"
            style={{
              display: "inline-block",
              marginTop: "35px",
              padding: "14px 36px",
              background: "linear-gradient(135deg,#f97316,#ea580c)",
              color: "#fff",
              borderRadius: "8px",
              fontWeight: "700",
              textDecoration: "none",
              boxShadow: "0 10px 25px rgba(249,115,22,0.35)",
            }}
          >
            Contact Us
          </Link>
        </section>

      </div>
    </div>
  );
}
